module.exports = __webpack_public_path__ + "img/26.ec9dc8ca.png";